/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateHome } from "../../../Redux/Slices/home.slice";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import { updateRental } from "../../../Redux/Slices/rentals.slice";
import { batterySwapSteps } from "../../../Modules/Trips/TripDetails/constants";
import {
  // getOverallSummary,
  // getTripById,
  getTripsV3,
} from "../../../Redux/APIs/tripsAPI";
import { getRentalList } from "../../../Redux/APIs/rentalsAPI";
import { getBatterySosByTrip } from "../../../Redux/APIs/batterySosAPI";

const ItemBody27 = ({ notification }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAcceptRequest = async () => {
    const tripId =
      notification?.metaData?.tripId || notification?.metaData?.trip_id;
    const rentalId =
      notification?.metaData?.rentalId || notification?.metaData?.rental_id;

    dispatch(updateHome({ key: "notificationPopupVisible", value: false }));
    dispatch(
      updateTrips({
        key: "batterySwapRequestModal",
        value: {
          visible: true,
          data: { step: batterySwapSteps.REQUEST_CREATED },
        },
      }),
    );
    if (tripId) {
      try {
        const response = await dispatch(getTripsV3({ tripId })).unwrap();
        const tripList = response?.result || [];
        let targetTrip = tripList.find(
          (item) => Number(item.id) === Number(tripId),
        );
        if (!targetTrip && tripList.length > 0) {
          [targetTrip] = tripList;
        }
        if (targetTrip) {
          dispatch(updateTrips({ key: "currentTrip", value: targetTrip }));
        }
      } catch (err) {
        console.error("Error fetching trip for notification", err);
      }

      navigate(`/trips/${tripId}`);
    } else if (rentalId) {
      try {
        const res = await dispatch(
          getRentalList({ searchQuery: rentalId }),
        ).unwrap();
        const rentalList = res?.response?.result || [];
        let targetRental = rentalList.find(
          (item) => Number(item.id) === Number(rentalId),
        );
        if (!targetRental && rentalList.length > 0) {
          [targetRental] = rentalList;
        }
        if (targetRental) {
          dispatch(
            updateRental({ key: "currentRental", value: targetRental }),
          );
        }
        await dispatch(getBatterySosByTrip({ rentalId: +rentalId })).unwrap();
      } catch (err) {
        console.error("Error fetching rental SOS for notification", err);
      }

      navigate(`/rentals/${rentalId}`);
    }
  };

  const driverName =
    notification?.metaData?.driverName ||
    notification?.metaData?.driver_name ||
    "Driver";
  const tripId =
    notification?.metaData?.tripId || notification?.metaData?.trip_id || "";
  const rentalId =
    notification?.metaData?.rentalId ||
    notification?.metaData?.rental_id ||
    "";

  let targetText = "Request";
  if (rentalId) {
    targetText = `Rental ${rentalId}`;
  } else if (tripId) {
    targetText = `Trip ${tripId}`;
  }

  return (
    <div>
      <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium text-primary capitalize">
          {driverName}{" "}
        </span>
        has raised an SoS request for{" "}
        <span className="font-medium"> battery swap </span> for{" "}
        <span className="font-medium"> {targetText} </span>. Do you want to
        accept?
      </p>

      {/* if action is performed, do not show the button */}
      {notification?.metaData?.action == 1 ? null : (
        <div className="mt-1 w-full flex items-center gap-x-2">
          <button
            type="button"
            className="flex-1 bg-primary hover:bg-primary-50 py-2 px-4 text-center rounded-md"
            onClick={handleAcceptRequest}
          >
            <p className="font-poppins text-xs font-medium text-background-white">
              View Details
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default ItemBody27;
